<mat-expansion-panel
    class="mat-elevation-z0"
    [expanded]="pinnedPanels[silentDataKey]"
    #buildDetailsExpansionPanel
>
    <mat-expansion-panel-header>
        <mat-panel-title>
            <mat-icon class="cb-grey cb-margin-right">home</mat-icon>
            <b>Build Details</b>
        </mat-panel-title>
        <mat-panel-description class="end-center flex-row">
            @if (buildDetailsExpansionPanel.expanded || silentData[silentDataKey]) {
                <button mat-icon-button (click)="togglePanelPinned($event, silentDataKey)">
                    <mat-icon svgIcon="pin" [ngClass]="{ 'cb-accent': silentData[silentDataKey] }">
                    </mat-icon>
                </button>
            }
        </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="flex-col">
        <div class="flex-wrap">
            <cb-display-value-new class="flex-50" label="Build Type">
                {{ lotMappedItem?.buildType.label | cbDasher }}
            </cb-display-value-new>
            @if (appliedDesignConceptField.isVisible) {
                <cb-display-value-new class="flex-50" label="Applied Design Concept">
                    {{ lotMappedItem?.appliedConceptName | cbDasher }}
                </cb-display-value-new>
            }
            @if (landAreaField.isVisible) {
                <cb-display-value-new class="flex-50" label="Land Area">
                    {{ lotMappedItem?.amenities?.landArea | cbDasher }}m²
                </cb-display-value-new>
            }
            @if (floorAreaField.isVisible) {
                <cb-display-value-new class="flex-50" label="Floor Area">
                    {{ lotMappedItem?.amenities?.floorArea | cbDasher }}m²
                </cb-display-value-new>
            }
            @if (bedroomsField.isVisible) {
                <cb-display-value-new class="flex-50" label="Bedroom">
                    {{ lotMappedItem?.amenities?.noBedrooms | cbDasher }}
                </cb-display-value-new>
            }
            @if (bathroomsField.isVisible) {
                <cb-display-value-new class="flex-50" label="Bathroom">
                    {{ lotMappedItem?.amenities?.noBathrooms | cbDasher }}
                </cb-display-value-new>
            }
            @if (livingroomsField.isVisible) {
                <cb-display-value-new class="flex-50" label="Living">
                    {{ lotMappedItem?.amenities?.noLivingRooms | cbDasher }}
                </cb-display-value-new>
            }
            @if (garagesField.isVisible) {
                <cb-display-value-new class="flex-50" label="Garage">
                    {{ lotMappedItem?.amenities?.noGarages | cbDasher }}
                </cb-display-value-new>
            }
            <cb-display-value-new class="flex-50" label="Carpark">
                {{ lotMappedItem?.amenities?.noCarparks | cbDasher }}
            </cb-display-value-new>
            <cb-display-value-new class="flex-50" label="Study">
                {{ lotMappedItem?.amenities?.noStudy | cbDasher }}
            </cb-display-value-new>
            @if (buildProgrammeTemplateField.isVisible) {
                <cb-display-value-new class="flex-50" label="Build Programme Template">
                    {{ lotMappedItem?.buildProgrammeTemplateId | cbDasher }}
                </cb-display-value-new>
            }
            @if (parentLotField.isVisible) {
                <cb-display-value-new class="flex-50" label="Apartment/Terrace">
                    {{ parentLotDto?.id | cbDasher }}
                </cb-display-value-new>
                <cb-display-value-new class="flex-50" label="Job Number">
                    {{ parentLotDto?.jobNumber | cbDasher }}
                </cb-display-value-new>
                <cb-display-value-new class="flex-50" label="Lot Type">
                    {{ parentLotDto?.lotType | cbEnumToLabel: LOT_TYPE_ENUM | cbDasher }}
                </cb-display-value-new>
            }
            @if (estimatedStartDateField.isVisible) {
                <cb-display-value-new class="flex-50" label="Estimated Start Date">
                    {{ lotMappedItem?.jobStart?.estimate | date: 'dd MMM yyyy' | cbDasher }}
                </cb-display-value-new>
            }
            @if (estimatedCompletionDateField.isVisible) {
                <cb-display-value-new class="flex-50" label="Estimated Completion Date">
                    {{ lotMappedItem?.jobComplete?.estimate | date: 'dd MMM yyyy' | cbDasher }}
                </cb-display-value-new>
            }
            @if (actualStartDateField.isVisible) {
                <cb-display-value-new class="flex-50" label="Actual Start Date">
                    {{ lotMappedItem?.jobStart?.actual | date: 'dd MMM yyyy' | cbDasher }}
                </cb-display-value-new>
            }
            @if (actualCompletionDateField.isVisible) {
                <cb-display-value-new class="flex-50" label="Actual Completion Date">
                    {{ lotMappedItem?.jobComplete?.actual | date: 'dd MMM yyyy' | cbDasher }}
                </cb-display-value-new>
            }
        </div>
    </div>
</mat-expansion-panel>
